<script lang="ts">
  import Menu from '@athena-lib/Icons/Menu.svelte';
  import type { DrawerButtonProps } from './types';

  const { onClick, label, sizeClass, displayLabel }: DrawerButtonProps = $props();
</script>

<button
  type="button"
  aria-label={!displayLabel ? label : undefined}
  onclick={onClick}
  class="flex appearance-none items-center gap-3 text-st-white"
>
  <Menu {sizeClass} />
  {#if displayLabel}
    <span class="sr-only text-sm md:not-sr-only">{label}</span>
  {/if}
</button>
